define((require) => {
    "use strict";

    const ImprovedModel = require("shared/zbone/ImprovedModel");
    const Configuration = require("shared/services/Configuration");

    /**
     * An experience model using microservices.
     *
     * @class MsCompanyModel
     * @constructor
     */
    return ImprovedModel.extend("MsCompanyModel", {

        _api: "msCompany",

        url() {
            return `${Configuration.microserviceCompanyUrl}${this.companyId}/users`;
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experienceOverview/experiencePermissions/MsCompanyModel.js